import { gql } from '@apollo/client';
import type { CompletionData } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLCompletionRequester {
  public getCompletionData = (): Promise<CompletionData | null> => {
    return graphQLRequester
      .query<{ completionData: CompletionData | null }>({
        query: gql`
          query completionData {
            completionData {
              vehicleInstalledCount
              fleetSize
              openTicketsToInstall
            }
          }
        `,
      })
      .then((response) => response.completionData ?? null);
  };
}

export default GraphQLCompletionRequester;
